<template lang="pug">
  validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
    validation-provider(
      :rules="{ required: true }"
      name="Заголовок для документа"
      vid="fileName"
      v-slot="{ errors, valid }"
    )
      v-text-field(
        v-model="document.original_name"
        :error-messages="errors"
        label="Заголовок для документа"
        rounded filled
      )
    validation-provider(
      rules="required"
      name="Документ"
      vid="document"
      v-slot="{ errors, valid }"
    )
      file-input.mt-4(
        v-model="document.filename"
        :url.sync="document.url"
        label="Нажмите для выбора договора"
        vid="file"
        name="Файл"
      )

    v-btn(
      color="success"
      @click="handleSubmit(save)"
      text
    ) Продолжить
</template>
<script>
import FileInput from '@/components/InputFields/FileInput.vue';

export default {
  components: {
    FileInput,
  },
  props: {
    value: { type: Object, default: () => ({}) },
    type: { type: Number, required: true },
  },
  data() {
    return {
      document: {},
    };
  },
  methods: {
    save() {
      this.$emit('success', {
        type: this.type,
        document: this.document,
        title: this.document.original_name,
      });
    },
  },
};
</script>
